module.exports = __webpack_public_path__ + "img/1-3.a2fa39da.jpg";